import React, { useEffect, useState } from "react";
import "../components/Category.css";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissions";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [canView, setCanView] = useState(false);
  const [canAdd, setCanAdd] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  // ✅ Fetch category data from API
  useEffect(() => {
    (async () => {
      try {
        const pView = (await hasPermission('master', 'category')) || (await hasPermission('master', 'viewcategory'));
        const pAdd = await hasPermission('master', 'addcategory');
        const pEdit = await hasPermission('master', 'editcategory');
        setCanView(!!pView);
        setCanAdd(!!pAdd);
        setCanEdit(!!pEdit);
      } catch {
        setCanView(false); setCanAdd(false); setCanEdit(false);
      }
    })();

    const fetchCategories = async () => {
      try {
        const token = (localStorage.getItem('session_token') || '').trim();
        const response = await fetch(`https://newerp.awasthivitality.com/api/category/list${token ? `?token=${encodeURIComponent(token)}` : ''}`,
          { headers: { ...(token ? { 'Authorization': `Bearer ${token}`, 'X-Session-Token': token } : {}) } });
        const data = await response.json();

        // ✅ Handle multiple possible API response formats
        if (Array.isArray(data.data)) {
          setCategories(data.data);
        } else if (Array.isArray(data)) {
          setCategories(data);
        } else {
          console.error("Unexpected API response format:", data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // ✅ Navigate to Add Category page
  const handleAddClick = () => {
    navigate("/Courier");
  };

  // ✅ Navigate to Edit Category page
  const handleEditClick = (category_id) => {
    if (!category_id) {
      console.error("Category ID is undefined");
      return;
    }
    navigate(`/CategoryEdit/${category_id}`);
  };
const handleDeleteClick = async (category_id) => {
  if (!category_id) {
    alert("Invalid category ID");
    return;
  }

  if (!window.confirm("Are you sure you want to delete this category?")) return;

  try {
    const response = await fetch(
      `https://newerp.awasthivitality.com/api/category/delete/${category_id}`,
      {
        method: "PUT"   // ✅ IMPORTANT
      }
    );

    console.log("Status:", response.status);

    // ✅ Safe JSON handling
    let result = {};
    try {
      result = await response.json();
    } catch {
      result = {};
    }

    if (response.ok && result.success !== false) {
      setCategories(prev =>
        prev.filter(cat => (cat.category_id || cat.id) !== category_id)
      );
      alert("Category deleted successfully");
    } else {
      alert(result.message || "Delete failed");
    }
  } catch (error) {
    console.error("Delete error:", error);
    alert("Something went wrong");
  }
};


  if (loading) {
    return <div className="categorylist-loading">Loading categories...</div>;
  }

  if (!canView) {
    return <div className="categorylist-container"><h2>Access Denied</h2><p>You do not have permission to view categories.</p></div>;
  }

  return (
    <div className="categorylist-container">
      <div className="categorylist-header">
        <h2>Category List</h2>
        {canAdd && (
          <button className="categorylist-add-btn" onClick={handleAddClick}>
            <FaPlus />
          </button>
        )}
      </div>

      <table className="categorylist-table">
        <thead>
          <tr>
            <th>S No</th>
            <th>Category Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {categories.length > 0 ? (
            categories.map((cat, index) => (
              <tr key={cat.category_id || cat.id || index}>
                <td>{index + 1}</td>
                <td>{cat.category_name || cat.name}</td>
            <td>
  {/* Edit Button */}
  <button
    className="categorylist-edit-btn"
    onClick={() => handleEditClick(cat.category_id || cat.id)}
  >
    <FaEdit />
  </button>

  {/* Delete Button */}
  <button
    className="categorylist-delete-btn"
    onClick={() => handleDeleteClick(cat.category_id || cat.id)}
    style={{ marginLeft: "10px" }}
  >
    <FaTrash />
  </button>
</td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                No categories found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CategoryList;
